<template>
  <div class="documentDetail">
    <div class="dh">
      <span class="cc">文档</span><i class="cc">/</i><span class="cc">待我签署</span><i>/</i><span>文档详情</span>
    </div>
    <div class="detailContent">
      <div class="title">文档详情</div>
      <div class="content">
        <p class="companyName">{{details.contractName}} <span class="status">{{details}}</span></p>
        <div class="infoWarp">
          <p class="sponsorName">
            <span class="tttt1">发起方：</span>
            {{details.creater}}
          </p>
          <p class="sponsorName">
            <span class="tttt1">发起时间：</span>
            {{details.sendTime}}
          </p>
          <p class="sponsorName" @click="openurl(details.url)">
            <span class="tttt1">文件下载：</span>
            <span class="sm">《{{details.contractName}}》 <i>立即下载</i></span>
          </p>
        </div>
        <div class="sponsor">
          <p class="name">签署方</p>
          <el-table
            :data="details.apiSignUserList"
            border
            class="tableWarp">
            <el-table-column
              prop="username"
              label="姓名/企业姓名"
              width="180">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="code"
              label="身份证号码">
            </el-table-column>
            <el-table-column
              prop="mail"
              label="电子邮箱">
            </el-table-column>
            <el-table-column
              prop="signTime"
              label="签约时间">
            </el-table-column>
            <el-table-column
              label="状态">
              <template slot-scope="scope">
                {{scope.row.status==0?'未签署':'已签署'}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="btns">
        5
        <el-button class="button" style="margin-right: 30px;" type="primary">签署</el-button>
        <el-button class="button">拒签</el-button>
      </div>
      <div class="btns">
        0
        <el-button class="button" style="margin-right: 30px;" type="primary">编辑</el-button>
        <el-button class="button">删除</el-button>
      </div>
      <div class="btns">
        6
        <el-button class="button" style="margin-right: 30px;" type="primary">支付</el-button>
      </div>
      <div class="btns">
        2
        <el-button class="button" style="margin-right: 30px;" type="primary">文档下载</el-button>
      </div>
      3
      <!--<span class="refuse">已拒签</span>-->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      data(){
        return{
          details:{}
        }
      },
      methods:{
        getData(){
          let _this = this;
          _this.ajpost('/api/contract/findContractInfo',{id:_this.$route.params.id},function (data) {
            console.log(data);
            _this.details = data.data;
          })
        }
      }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/home/documentList/documentDetail.vue